import React from 'react';
import { UserModel } from '../../../interfaces/user.interface';
import { CONFIG } from '../../../config/mainConfig';
import PlanFeatureList from './PlanFeatureList';
import PlanDetails from './PlanDetails';
import { PlanDetailsModel } from '../../../interfaces/plan.interface';

const features = [
  'Access to "Book Builder" craft personalized children\'s books for your loved one.',
  'Unlimited Story Editing.',
  'Unlimited PDFs Generated.'
];

interface UserPlanDetailsProps {
  user: UserModel | null;
  loader: any;
  setOpenDialog: (state: boolean) => void;
  currentPlanDescription: PlanDetailsModel | null | undefined;
}

const UserPlanDetails: React.FC<UserPlanDetailsProps> = ({
                                                           user,
                                                           loader,
                                                           setOpenDialog,
                                                           currentPlanDescription
                                                         }) => {
  return (
    <div
      className={
        user?.plan == null || user?.plan?.name === CONFIG.PROMO_PLAN
          ? 'hidden'
          : ' sm:w-[100%] md:w-[50%] '
      }
    >
      {user?.plan?.name && user?.plan?.name !== CONFIG.PROMO_PLAN && (
        <PlanFeatureList features={features} />
      )}

      {user?.plan?.name && user?.plan?.name !== CONFIG.PROMO_PLAN && (
        <PlanDetails
          user={user}
          loader={loader}
          currentPlanDescription={currentPlanDescription}
          setOpenDialog={() => setOpenDialog(true)} />
      )}
    </div>
  );
};

export default UserPlanDetails;
